import React from 'react';
import { useLanguage } from '../context/LanguageContext';

interface Props {
  label: string;
  total: number | null;
  status: 'pending' | 'ready' | 'error' | 'unavailable';
  retry: () => void;
  canRetry: boolean;
}

export default function SearchCountLabel({ label, total, status, retry, canRetry }: Props) {
  const { t } = useLanguage();
  return (
    <p aria-live="polite" className="text-sm text-gray-500 mb-4">
      {label}: <span className="font-bold text-gray-800">
        {total != null ? total.toLocaleString('ru-RU') : t(`lots.count.${status}`)}
      </span>
      {status === 'error' && canRetry && (
        <button type="button" onClick={retry} className="ml-2 font-semibold text-goszakup-700 underline">{t('lots.retry')}</button>
      )}
    </p>
  );
}
